import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const Notification = ({ message, type, onClose }) => {
  const bgColor = type === "error" ? "bg-danger" : "bg-success";
  const textColor = "text-white";

  return (
    <Popup
      open={true}
      closeOnDocumentClick={false}
      modal={false}
      overlayStyle={{ background: "transparent" }}
      contentStyle={{
        position: "fixed",
        top: "60px",
        right: "20px",
        left: "auto",
        bottom: "auto",
        margin: 0,
        padding: 0,
        border: "none",
        background: "transparent",
        width: "auto",
        maxWidth: "350px",
        boxShadow: "none",
      }}
    >
      <div
        className={`alert ${bgColor} ${textColor} d-flex justify-content-between align-items-center shadow`}
        role="alert"
      >
        <span>{message}</span>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={onClose}
          aria-label="Close"
        ></button>
      </div>
    </Popup>
  );
};

export default Notification;
